module.exports = __webpack_public_path__ + "static/media/sport.68995439.jpg";